var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone_wrapper"},[(_vm.verified)?_c('phone-number-valid',{attrs:{"phone-code":_vm.country.value,"phone":_vm.phone_number}}):_c('div',[(!_vm.started)?_c('phone-number-field',{model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}):_c('phone-number-pin')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }